import Prism from 'prismjs';

// Custom AppSheet Definition
Prism.languages['appsheet'] = {
    'comment': /\/\*[\s\S]*?\*\/|([^:]|^)\/\/.*/,
    'string': { pattern: /"(?:""|[^"])*"/, greedy: true },
    'variable': /\[[^\]]+\]/,
    'function': /\b(SELECT|LOOKUP|FILTER|ANY|COUNT|IF|AND|OR|NOT|IN|CONCATENATE|UNIQUE|SUM|AVERAGE|MIN|MAX|STDEVP|COUNTBLANK|COUNTIF|ISBLANK|ISNOTBLANK|TEXT|DATE|TIME|NOW|TODAY|HERE|USEREMAIL|USERNAME|CONTEXT|LINKTOFORM|LINKTOROW|LINKTOVIEW)\b/i,
    'keyword': /\b(TRUE|FALSE|_THISROW|_THISROW_BEFORE|_THISROW_AFTER)\b/i,
    'operator': /[<>!=&+-/*]/,
    'punctuation': /[()\[\],]/
};

// Custom Google Sheets Definition
Prism.languages['sheets'] = {
    'string': /"[^"]*"/,
    'variable': /\$?[A-Z]+\$?\d+(:\$?[A-Z]+\$?\d+)?/,
    'function': /\b(SUM|AVERAGE|VLOOKUP|HLOOKUP|QUERY|IMPORTRANGE|INDEX|MATCH|IFERROR|ARRAYFORMULA|FILTER|SORT|UNIQUE|JOIN|SPLIT|TEXTJOIN)\b/i,
    'operator': /[<>=!&+-/*^]/,
    'punctuation': /[(),;]/
};

export const highlightCode = (code, type) => {
    let langKey = type?.toLowerCase() || 'javascript';

    const grammarMap = {
        // --- Code Mappings ---
        'javascript': 'javascript',
        'apps script': 'javascript',
        'vite': 'javascript',
        'typescript': 'typescript',
        'react': 'jsx',
        'html': 'markup',
        'sheets': 'sheets',
        'google sheets': 'sheets',
        'appsheet': 'appsheet',
        'python': 'python',
        'big query sql': 'sql',
        'markdown': 'markdown',
        'json': 'json',

        // --- AI Mappings ---
        'prompt': 'markdown',
        'gem': 'markdown',
        'system prompt': 'markdown',
        'few-shot': 'markdown',
        'context': 'markdown',
        'ai code': 'javascript',

        // --- Links Mappings ---
        'github repo': 'markdown',
        'dev docs': 'markdown',
        'community forum': 'markdown',
        'applications': 'markdown',
        'curl commands': 'bash'
    };

    langKey = grammarMap[langKey] || 'markdown';
    const grammar = Prism.languages[langKey] || Prism.languages.markdown;

    return Prism.highlight(code || '', grammar, langKey);
};